export const QUESTION_TYPE_UPLOAD = "type_upload"